import { apiClient } from '@/config/api';
import { ApiResponse } from '@/types/status';

export interface RobotTxt {
    _id: string;
    name: string;
    content: string;
    description: string;
    isActive: boolean;
    lastModifiedBy:
    | string
    | {
        _id: string;
        username: string;
        name?: string;
        email?: string;
    };
    createdAt: string;
    updatedAt: string;
}

export interface UpdateRobotTxtDto {
    content?: string;
    description?: string;
    isActive?: boolean;
}

export interface ValidateRobotTxtDto {
    content: string;
}

export interface RobotTxtValidationResult {
    isValid: boolean;
    errors: string[];
    warnings: string[];
}

const ROBOT_TXT_ENDPOINTS = {
    GET: '/robot-txt',
    UPDATE: '/robot-txt',
    RESET: '/robot-txt/reset',
    TOGGLE_STATUS: '/robot-txt/toggle-status',
    VALIDATE: '/robot-txt/validate',
};

export const robotTxtService = {
    async get(): Promise<ApiResponse<RobotTxt>> {
        return apiClient.get(ROBOT_TXT_ENDPOINTS.GET);
    },

    async update(data: UpdateRobotTxtDto): Promise<ApiResponse<RobotTxt>> {
        return apiClient.put(ROBOT_TXT_ENDPOINTS.UPDATE, data);
    },

    async reset(): Promise<ApiResponse<RobotTxt>> {
        return apiClient.post(ROBOT_TXT_ENDPOINTS.RESET);
    },

    async toggleStatus(): Promise<ApiResponse<RobotTxt>> {
        return apiClient.post(ROBOT_TXT_ENDPOINTS.TOGGLE_STATUS);
    },

    async validate(data: ValidateRobotTxtDto): Promise<ApiResponse<RobotTxtValidationResult>> {
        return apiClient.post(ROBOT_TXT_ENDPOINTS.VALIDATE, data);
    },
};
